// Components
import TableRow from './TableRow'
import CompanyUserForm from '../../forms/CompanyUserForm'
import { submitUserInvitationForm } from '../userInvitationsHelpers'
import { addUserInvitation, closeUserInvitationForm } from '../../../actions/companyUsers'

const UserInvitationsTable = ({ hasOpenForm, invitations, userInvitationsUrl, dispatch }) => {
  return (
    <div id="user-invitations-table-div">
      <table className="table">
        <thead>
          <tr>
            <th>Email</th>
            <th>Date</th>
            <th>Access</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {
            hasOpenForm && <CompanyUserForm submitFormHandler={({ event, onError }) => submitUserInvitationForm({
              event,
              onError,
              submitUrl: userInvitationsUrl,
              onSuccess: data => dispatch(addUserInvitation(data))
            })}
            closeFormHandler={() => dispatch(closeUserInvitationForm())} />
          }
          {
            invitations.map(invitation => <TableRow key={invitation.id} invitation={invitation} />)
          }
        </tbody>
      </table>
    </div>
  )
}
const mapStateToProps = ({ hasOpenForm, invitations, userInvitationsUrl }) => ({ hasOpenForm, invitations, userInvitationsUrl })
export default connect(mapStateToProps)(UserInvitationsTable)



// WEBPACK FOOTER //
// ./app/javascript/reactFeatures/company-users/components/user-invitations/components/UserInvitationsTable.js